import { useState, useEffect } from 'react';
import { useMsal, useAccount } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import { jwtDecode } from "jwt-decode";
import JWTPayload from '../models/JWTPayload';

export const useUserRoles = () => {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0]);
  const [roles, setRoles] = useState<string[]>([]);

  useEffect(() => {
    const fetchRoles = async () => {
      if (!account) {
        throw Error('No active account! Verify a user has been signed in.');
      }

      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account,
      });

      const decodedToken: JWTPayload = jwtDecode<JWTPayload>(response.accessToken);
      setRoles(decodedToken.roles || []);
    };

    fetchRoles();
  }, [account, instance]);

  return roles;
};

export default useUserRoles;
